import mixpanel from 'mixpanel-browser';
import { getUserInLocalStorage } from '../../localStorage/localStorage';

type MixPanelEventName = 'user login' | 'lead update' | 'view_guide' | 'confirm drop' | 'mail_click';

export const logMixPanelEvent = (
  eventName: MixPanelEventName,
  additionalProperties = {},
  trackNotAuthUser = false
) => {
  const user = getUserInLocalStorage();
  if (!user && !trackNotAuthUser) {
    return;
  }
  mixpanel.track(eventName, {
    user: user?.email || 'unknown',
    ...additionalProperties,
  });
};
